import React, { useCallback } from 'react';
import { Flex, TabPane, TextInput, Label, Pane } from '@leverege/ui-elements';
import { Attributes } from '@leverege/ui-attributes';
import { ModelListEditor, ItemLayoutSelector } from '@leverege/ui-plugin';
import { useValueChange } from '@leverege/ui-hooks';
import I18N from '@leverege/i18n';
import classnames from 'classnames';
import AggViewListRenderer from "./AggViewListRenderer.js";
import { AggEditorFactory, AggModelFactory, AggViewModelFactory, AggViewEditorFactory } from "../types/index.js";
import Views from "../Views.js";
import AggItemModel from "./AggItemModel.js";
import S from './AggItemEditor.css';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const {
  t,
  tIcon
} = I18N.ns('molten.dataViewers.aggregations.AggItemEditor');
export default function AggItemEditor(props) {
  const {
    value,
    onChange,
    eventData,
    objectType,
    delegate,
    blueprint,
    relationship
  } = props;
  const attributes = Attributes.getAttributesFor(objectType);
  const onAddView = useCallback(evt => {
    const model = AggViewModelFactory.get(evt.value.value);
    const val = model.create();
    onChange({
      value: AggItemModel.addViewModel(value, val),
      data: eventData
    });
  }, [onChange, eventData, value]);
  const onModelChange = useValueChange(AggItemModel, props);
  const onChangeViewModel = useCallback(evt => {
    onChange({
      value: evt.value,
      data: eventData
    });
  }, [onModelChange, value, eventData]);
  const contentHeader = item => {
    if (!item) {
      return null;
    }
    return /*#__PURE__*/_jsxs("div", {
      children: [item?.displayName, " ", t('header')]
    });
  };
  const header = item => {
    const model = AggModelFactory.get(value.model);
    const viewTypes = Views.getViewsFor(model.getValueType(value.model));
    return /*#__PURE__*/_jsx(Flex, {
      align: "center",
      justify: "space-between",
      children: /*#__PURE__*/_jsx(ItemLayoutSelector, {
        options: viewTypes,
        onSelect: onAddView,
        icon: tIcon('icon', 'fa fa-plus'),
        title: t('title')
      })
    });
  };
  return /*#__PURE__*/_jsxs(TabPane, {
    children: [/*#__PURE__*/_jsxs(TabPane.Tab, {
      tabId: "aggregation",
      tabName: t('aggregationTabName'),
      children: [/*#__PURE__*/_jsxs(Pane, {
        variant: "editor",
        className: classnames(S.grid, S.sub),
        children: [/*#__PURE__*/_jsx(Label, {
          htmlFor: "name",
          children: t('nameLabel')
        }), /*#__PURE__*/_jsx(TextInput, {
          id: "name",
          eventData: "setName",
          onChange: onModelChange,
          value: AggItemModel.getName(value)
        })]
      }), AggEditorFactory.create(value.model, {
        onChange: onModelChange,
        eventData: 'setModel',
        attributes,
        delegate,
        blueprint,
        relationship,
        objectType,
        className: S.fill
      }) || t('unknown')]
    }), /*#__PURE__*/_jsx(TabPane.Tab, {
      tabId: "views",
      tabName: t('viewsTabName'),
      children: /*#__PURE__*/_jsx("div", {
        className: S.editor,
        children: /*#__PURE__*/_jsx(ModelListEditor, {
          value: value,
          listClassName: S.list,
          listHeader: header,
          selectionHeader: contentHeader,
          eventData: "setViewModels",
          model: AggItemModel.viewModels(),
          modelEditorFactory: AggViewEditorFactory,
          selectedProps: {
            relationship,
            delegate,
            objectType
          },
          renderer: AggViewListRenderer,
          onChange: onChangeViewModel
        })
      })
    })]
  });
}